import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '#shared/components/UI';
import { usePermissionsContext } from './PermissionsContext';

type PermissionsEnableAllButtonProps = ComponentProps<typeof Button>;

/** `Permissions.EnableAllButton`: turns on every toggle. Hidden while searching and in read-only mode. */
export default function PermissionsEnableAllButton(props: PermissionsEnableAllButtonProps) {
  const { editor, readOnly } = usePermissionsContext();
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.Permissions' });

  if (editor.isFiltering || readOnly) return null;

  return (
    <Button type="button" colorScheme="secondary" onClick={editor.enableAll} {...props}>
      {props.children ?? t('enableAll', { defaultValue: 'Enable All' })}
    </Button>
  );
}
